(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filter"] && !Shopify.designMode) return;
  try {
    // Close-outside handling for the filter/sort disclosures. A transparent
  // full-viewport backdrop used to do this, but it swallowed touch scrolling
  // and made the page feel frozen while a dropdown was open, so the page is
  // left fully scrollable and outside clicks are detected here instead.
  var DISCLOSURE_SELECTOR = '.filter-disclosure[open], .sort-disclosure[open]';

  document.addEventListener('pointerdown', function (e) {
    var open = document.querySelectorAll(DISCLOSURE_SELECTOR);

    for (var i = 0; i < open.length; i++) {
      if (!open[i].contains(e.target)) {
        open[i].removeAttribute('open');
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;

    var open = document.querySelectorAll(DISCLOSURE_SELECTOR);

    for (var i = 0; i < open.length; i++) {
      open[i].removeAttribute('open');
    }
  });

  // Only one disclosure open at a time
  document.addEventListener(
    'toggle',
    function (e) {
      if (!e.target.classList.contains('filter-disclosure') && !e.target.classList.contains('sort-disclosure')) return;
      if (!e.target.open) return;

      var open = document.querySelectorAll(DISCLOSURE_SELECTOR);

      for (var i = 0; i < open.length; i++) {
        if (open[i] !== e.target) {
          open[i].removeAttribute('open');
        }
      }
    },
    true,
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-selector"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.localization-selector').forEach((details) => {
    document.addEventListener('click', (event) => {
      if (details.open && !details.contains(event.target)) {
        details.open = false;
      }
    });

    details.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && details.open) {
        event.preventDefault();
        details.open = false;
        const summary = details.querySelector('summary');
        if (summary) summary.focus();
      }
    });

    details.addEventListener('toggle', () => {
      if (!details.open) return;
      const active = details.querySelector('[aria-current="true"]');
      if (active) {
        active.focus({ preventScroll: true });
        active.scrollIntoView({ block: 'nearest' });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-back-in-stock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('back-in-stock')) {
    const KLAVIYO_BIS_ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions';
    const KLAVIYO_REVISION = '2026-07-15';

    class BackInStock extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[type="email"]');
        this.button = this.querySelector('.back-in-stock__submit');
        this.status = this.querySelector('.back-in-stock__status');
        this.fields = this.querySelector('.back-in-stock__fields') || this.input;
        this.form = this.ensureForm();

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleVariant = this.handleVariant.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.keepInView = this.keepInView.bind(this);
        this.form.addEventListener('submit', this.handleSubmit);
        document.addEventListener('variant:updated', this.handleVariant);
        this.input.addEventListener('focus', this.handleFocus);
        this.input.addEventListener('blur', this.handleBlur);
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener('submit', this.handleSubmit);
        document.removeEventListener('variant:updated', this.handleVariant);
        this.input.removeEventListener('focus', this.handleFocus);
        this.input.removeEventListener('blur', this.handleBlur);
        this.handleBlur();
      }

      // Phone keyboards can open over the field without the page scrolling it into
      // view (seen on iPhone). Once the keyboard has opened, scroll the email row so
      // it sits fully inside the visible area, below the sticky header.
      handleFocus() {
        document.documentElement.classList.add('is-typing-back-in-stock');
        if (window.visualViewport) window.visualViewport.addEventListener('resize', this.keepInView);
        clearTimeout(this.focusTimer);
        this.focusTimer = setTimeout(this.keepInView, 350);
      }

      handleBlur() {
        document.documentElement.classList.remove('is-typing-back-in-stock');
        if (window.visualViewport) window.visualViewport.removeEventListener('resize', this.keepInView);
        clearTimeout(this.focusTimer);
      }

      keepInView() {
        if (document.activeElement !== this.input) return;
        const margin = 16;
        const viewport = window.visualViewport;
        const visibleTop = viewport ? viewport.offsetTop : 0;
        const visibleBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
        const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        const rect = this.fields.getBoundingClientRect();

        if (rect.bottom + margin > visibleBottom) {
          window.scrollBy({ top: rect.bottom + margin - visibleBottom });
        } else if (rect.top - margin < visibleTop + header) {
          window.scrollBy({ top: rect.top - margin - visibleTop - header });
        }
      }

      ensureForm() {
        const id = this.dataset.formId;
        let form = document.getElementById(id);
        if (!form) {
          form = document.createElement('form');
          form.id = id;
          form.hidden = true;
          document.body.appendChild(form);
        }
        return form;
      }

      handleVariant(event) {
        const detail = event.detail || {};
        if (detail.sectionId && detail.sectionId !== this.dataset.sectionId) return;
        if (!detail.variant) return;

        this.dataset.variantId = detail.variant.id;
        this.classList.remove('is-choosing', 'is-subscribed');
        this.setStatus('', '');
        this.button.disabled = false;
        this.hidden = Boolean(detail.variant.available);
      }

      setStatus(message, state) {
        this.status.textContent = message;
        this.status.dataset.state = state;
      }

      async handleSubmit(event) {
        event.preventDefault();

        const email = this.input.value.trim();
        const variantId = this.dataset.variantId;
        if (!email || !variantId) return;

        this.button.disabled = true;
        this.setStatus('', '');

        const body = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email } } },
              channels: ['EMAIL'],
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantId}` } },
            },
          },
        };

        try {
          const response = await fetch(
            `${KLAVIYO_BIS_ENDPOINT}?company_id=${encodeURIComponent(this.dataset.companyId)}`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/vnd.api+json',
                Accept: 'application/vnd.api+json',
                revision: KLAVIYO_REVISION,
              },
              body: JSON.stringify(body),
            },
          );
          if (!response.ok) throw new Error(`Klaviyo responded ${response.status}`);

          this.input.value = '';
          this.classList.add('is-subscribed');
          this.setStatus(this.dataset.success, 'success');
        } catch (error) {
          this.button.disabled = false;
          this.setStatus(this.dataset.error, 'error');
        }
      }
    }

    customElements.define('back-in-stock', BackInStock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-low-stock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('low-stock')) {
    class LowStock extends HTMLElement {
      connectedCallback() {
        this.text = this.querySelector('.low-stock__text');
        const data = this.querySelector('[data-low-stock-counts]');
        try {
          this.counts = JSON.parse(data ? data.textContent : '{}');
        } catch (error) {
          this.counts = {};
        }

        this.handleVariant = this.handleVariant.bind(this);
        document.addEventListener('variant:updated', this.handleVariant);
      }

      disconnectedCallback() {
        document.removeEventListener('variant:updated', this.handleVariant);
      }

      handleVariant(event) {
        const detail = event.detail || {};
        if (detail.sectionId && detail.sectionId !== this.dataset.sectionId) return;
        if (!detail.variant) return;

        const count = detail.variant.available ? this.counts[detail.variant.id] : 0;
        if (!count) {
          this.hidden = true;
          this.text.textContent = '';
          return;
        }

        const template = count === 1 ? this.dataset.one : this.dataset.other;
        this.text.textContent = template.replace('[count]', count);
        this.hidden = false;
      }
    }

    customElements.define('low-stock', LowStock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-ratings"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-reviews-link]');
    if (!link) return;

    const target = document.getElementById('looxReviews');
    if (!target) return;

    event.preventDefault();
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-view-counter"] && !Shopify.designMode) return;
  try {
    /*
   * Each counter runs itself, so a second counter on the page, or one put back
   * by a section re-render, keeps counting too. The number stays within the
   * block's minimum and maximum and moves every update-interval seconds.
   */
  if (!customElements.get('view-counter')) {
    class ViewCounter extends HTMLElement {
      connectedCallback() {
        this.numberElement = this.querySelector('.pdp-view-counter-number');
        this.labelElement = this.querySelector('.pdp-view-counter-label');
        this.verbElement = this.querySelector('.pdp-view-counter-verb');
        if (!this.numberElement) return;

        this.min = parseInt(this.dataset.minNumber, 10) || 2;
        this.max = Math.max(parseInt(this.dataset.maxNumber, 10) || 12, this.min);
        const seconds = parseInt(this.dataset.updateInterval, 10) || 30;

        this.show(this.random(this.min, this.max));
        clearInterval(this.timer);
        this.timer = setInterval(() => this.step(), seconds * 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      random(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }

      step() {
        const current = parseInt(this.numberElement.textContent, 10) || this.min;
        const change = Math.random();
        let next;

        if (change < 0.4) {
          next = current + this.random(1, 3);
        } else if (change < 0.7) {
          next = current - this.random(1, 2);
        } else {
          next = this.random(this.min, this.max);
        }

        this.show(Math.min(Math.max(next, this.min), this.max));
      }

      show(number) {
        this.numberElement.textContent = number;
        const one = number === 1;
        if (this.labelElement) this.labelElement.textContent = one ? 'Person' : 'People';
        if (this.verbElement) this.verbElement.textContent = one ? 'Is' : 'Are';
      }
    }

    customElements.define('view-counter', ViewCounter);
  }
  } catch(e) { console.error(e); }
})();

})();
